import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { TagInput } from './TagInput';

export function LeadSaleForm(props) {
  var formState = useState({
    name: props.item ? props.item.name : '',
    description: props.item ? props.item.description : '',
    category: props.item ? props.item.category : '',
    cost: props.item ? (props.item.cost || '') : '',
    vendor: props.item ? (props.item.vendor || '') : '',
    tags: props.item ? (props.item.tags || []) : [],
    price_onetime: props.item ? (props.item.price_onetime || '') : '',
    price_monthly: props.item ? (props.item.price_monthly || '') : '',
    price_yearly: props.item ? (props.item.price_yearly || '') : ''
  });
  var form = formState[0];
  var setForm = formState[1];
  var tagInputState = useState('');

  function handleChange(field, value) {
    var updated = {};
    for (var key in form) { updated[key] = form[key]; }
    updated[field] = value;
    setForm(updated);
  }

  return (
    <div className="space-y-4">
      <div><label className="block text-sm font-medium text-gray-700 mb-1">Lead Sale Name *</label><input type="text" value={form.name} onChange={(e) => handleChange('name', e.target.value)} className="w-full px-4 py-2 border rounded-lg" placeholder="e.g., Florida DME Leads Package" /></div>
      <div><label className="block text-sm font-medium text-gray-700 mb-1">Description</label><textarea value={form.description} onChange={(e) => handleChange('description', e.target.value)} className="w-full px-4 py-2 border rounded-lg" rows="2" placeholder="What the client receives" /></div>
      <div><label className="block text-sm font-medium text-gray-700 mb-1">Category</label><input type="text" value={form.category} onChange={(e) => handleChange('category', e.target.value)} className="w-full px-4 py-2 border rounded-lg" placeholder="e.g., Lead Packages" /></div>
      <div className="grid grid-cols-2 gap-4">
        <div><label className="block text-sm font-medium text-gray-700 mb-1">Vendor</label><input type="text" value={form.vendor} onChange={(e) => handleChange('vendor', e.target.value)} className="w-full px-4 py-2 border rounded-lg" placeholder="e.g., Internal" /></div>
        <div><label className="block text-sm font-medium text-gray-700 mb-1">Cost (Your Cost)</label><div className="relative"><span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">$</span><input type="number" step="0.01" value={form.cost} onChange={(e) => handleChange('cost', e.target.value)} className="w-full pl-7 pr-3 py-2 border rounded-lg" placeholder="0.00" /></div></div>
      </div>
      <TagInput tags={form.tags} tagInput={tagInputState[0]} setTagInput={tagInputState[1]} onAdd={() => { var t = tagInputState[0].trim(); if (t && form.tags.indexOf(t) === -1) handleChange('tags', form.tags.concat([t])); tagInputState[1](''); }} onRemove={(t) => handleChange('tags', form.tags.filter(x => x !== t))} />
      <div className="pt-4 border-t">
        <label className="block text-sm font-medium text-gray-700 mb-3">Pricing</label>
        <div className="grid grid-cols-3 gap-3">
          <PriceBox label="One-Time" color="purple" value={form.price_onetime} onChange={(v) => handleChange('price_onetime', v)} />
          <PriceBox label="Monthly" color="blue" value={form.price_monthly} onChange={(v) => handleChange('price_monthly', v)} />
          <PriceBox label="Yearly" color="green" value={form.price_yearly} onChange={(v) => handleChange('price_yearly', v)} />
        </div>
      </div>
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-800">
        When this item is added to an invoice, an upload button will appear to attach files. Files are delivered to the client portal only after payment.
      </div>
      <div className="flex justify-end gap-3 pt-4">
        <Button variant="outline" onClick={props.onClose}>Cancel</Button>
        <Button onClick={() => props.onSave({ name: form.name, description: form.description, category: form.category, cost: form.cost ? parseFloat(form.cost) : null, vendor: form.vendor || null, tags: form.tags || [], price_onetime: form.price_onetime ? parseFloat(form.price_onetime) : null, price_monthly: form.price_monthly ? parseFloat(form.price_monthly) : null, price_yearly: form.price_yearly ? parseFloat(form.price_yearly) : null })} className="bg-[#84CC16] hover:bg-[#65a30d]">{props.item ? 'Update' : 'Create Lead Sale'}</Button>
      </div>
    </div>
  );
}

function PriceBox({ label, color, value, onChange }) {
  var bg = color === 'purple' ? 'bg-purple-50 border-purple-200' : color === 'blue' ? 'bg-blue-50 border-blue-200' : 'bg-green-50 border-green-200';
  var lbl = color === 'purple' ? 'text-purple-700' : color === 'blue' ? 'text-blue-700' : 'text-green-700';
  return (
    <div className={`rounded-lg p-3 border ${bg}`}>
      <label className={`block text-xs font-medium ${lbl} mb-2`}>{label}</label>
      <div className="relative"><span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">$</span><input type="number" step="0.01" value={value} onChange={(e) => onChange(e.target.value)} className="w-full pl-7 pr-3 py-2 border rounded-lg" placeholder="0.00" /></div>
    </div>
  );
}
